exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*** variables ***/\n/*** mixins ***/\n.bg_wrap[data-v-4f6ca7ca] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n}\n#particles-js[data-v-4f6ca7ca] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
